import React from 'react';
import { Provider } from 'react-redux';

import Base from './Base.jsx';

import NFTTokenUtility from '../Components/NFTTokenUtility/index.jsx';

import Store from '../Store/index.js';


class EntryPoint extends Base {
  id() {
    return 'cs-nft-token-utility';
  }

  renderElement(element) {
    var id = element.dataset.id;
    if (id) {
      id = parseInt(id);
      if (isNaN(id)) {
        id = undefined;
      }
    }

    return (
      <Provider store={Store}>
        <NFTTokenUtility id={id} />
      </Provider>
    );
  }
}


export default EntryPoint;

